import api from './api';

const founderService = {
  async getAll() {
    const response = await api.get('/founders');
    return response.data;
  },
  async getOne(id) {
    const response = await api.get(`/founders/${id}`);
    return response.data;
  },
  async create(data) {
    const response = await api.post('/founders', data);
    return response.data;
  },
  async update(id, data) {
    const response = await api.put(`/founders/${id}`, data);
    return response.data;
  },
  async remove(id) {
    const response = await api.delete(`/founders/${id}`);
    return response.data;
  },
  async addInvestment(id, data) {
    const response = await api.post(`/founders/${id}/investments`, data);
    return response.data;
  },
  async cancelInvestment(founderId, investmentId, reason) {
    const response = await api.post(`/founders/${founderId}/investments/${investmentId}/cancel`, { reason });
    return response.data;
  },
};

export default founderService;
